import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-protocollist',
  templateUrl: './protocollist.component.html',
  styleUrls: ['./protocollist.component.css']
})
export class ProtocollistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
